import React from 'react';
import { useUniqueName } from '../../hooks/useUniqueName';
import FieldSet from '../FieldSet/FieldSet';
import { BareDatePicker } from './BareDatePicker';
import { type DatePickerProps } from './DatePicker.types';

/**
 * DatePicker allows the user to pick a date.  The `value` and the `onChange` value
 * are ISO8601 date string (e.g. 2022-10-31).
 */
const DatePicker: React.FC<DatePickerProps> = (props) => {
  const { name: givenName, label, errorText, hintText, ...rest } = props;
  const name = useUniqueName(givenName);

  return (
    <FieldSet
      colorMode={props.colorMode}
      name={name}
      label={props.label}
      errorText={errorText}
      hintText={hintText}
    >
      <BareDatePicker {...rest} name={name} showTodayButton />
    </FieldSet>
  );
};

export default React.memo(DatePicker);
